module.exports = __webpack_public_path__ + "static/img/anxunu01.cd817676.png";